import React, { useState } from 'react';

import PropTypes from 'prop-types';

import Modal from 'components/new_ui/Modal/Modal';
import { Button } from 'react-bootstrap5';

export default function Skip({ onCloseSkip, onSkipNow }) {
  const [loading, setLoading] = useState(false);

  const onStartLater = () => {
    setLoading(true);
    onSkipNow();
  };

  const onStartNow = () => {
    onCloseSkip();
  };

  return (
    <Modal show>
      <p className="text-danger">
        This Talent Assessment (TA) is a key component of your
        LeggUP coaching experience, designed to help you gauge your development and
        identify areas for growth.
      </p>
      <p>
        Upon completion of the TA, you will receive a detailed Growth Report
        that will highlight your accomplishments and provide insights to further your
        personal and professional success.
      </p>

      <p>
        Feel free to take the TA at this stage in your coaching journey, or you may
        opt to complete it when you log in next time.
      </p>
      <p>
        <strong>Please note:</strong>
        {' '}
        Completing the TA at regular intervals is beneficial to maximize the benefits of your coaching sessions.
      </p>
      <footer className="d-flex justify-content-between">
        <Button
          variant="outline-primary"
          disabled={loading}
          onClick={onStartLater}
        >
          Start Later
        </Button>

        <Button
          disabled={loading}
          onClick={onStartNow}
        >
          Start Now
        </Button>
      </footer>
    </Modal>
  );
}

Skip.propTypes = {
  onCloseSkip: PropTypes.func.isRequired,
  onSkipNow: PropTypes.func.isRequired,
};
